import { Vue } from 'vue-property-decorator'

export const campaignStatus = () => {
  return {
    DRAFT: { key: 50500001, label: Vue.prototype.$gettext('CAMPAIGN_STATUS.50500001') },
    ACTIVE: { key: 50500002, label: Vue.prototype.$gettext('CAMPAIGN_STATUS.50500002') },
    PAUSED: { key: 50500003, label: Vue.prototype.$gettext('CAMPAIGN_STATUS.50500003') },
    ENDED: { key: 50500004, label: Vue.prototype.$gettext('CAMPAIGN_STATUS.50500004') }
  }
}
